// Token palette — kept in sync with src/ui/colors.ts (native). Colour constants,
// not game logic — safe to duplicate rather than reach into src/ui/.
import type { Color } from '@gametypes';

export const COLOR_PALETTE: Record<Color, string> = {
  red: '#FF4D4D',
  blue: '#4D94FF',
  green: '#4DFF88',
  yellow: '#FFE44D',
  purple: '#B44DFF',
  orange: '#FF944D',
};

export const COLOR_GLOW: Record<Color, string> = {
  red: '#FF9999',
  blue: '#99C5FF',
  green: '#99FFBB',
  yellow: '#FFF399',
  purple: '#D999FF',
  orange: '#FFCC99',
};
